export default __webpack_public_path__ + "static/media/docxThumbnail.596cd2d5.svg";